(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Forms = Lfl.Forms || {};

    (function (Forms, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Forms, 'SingleSubmitEnforcer')) {
            return;
        }

        /**
         * Enforces that forms are only submitted once.
         *
         * Inspiration: https://laracasts.com/discuss/channels/laravel/preventing-multiple-submits
         *
         * @memberOf Lfl.Forms
         */
        Lfl.Forms.SingleSubmitEnforcer = Forms.SingleSubmitEnforcer || {};

        (function (SingleSubmitEnforcer, $, undefined) {
            const DEFAULT_PATH = '[data-single-click]';
            const animators = new Map();

            /**
             * Engages the mechanism for default buttons.
             *
             * As of now relies on submit buttons (or other form submitting elements) containing the specified attribute.
             *
             * Note: Currently the mechanism does not "disengage", cannot be aborted. We could do that in the future -
             * link: Forms::PreventMultipleSubmits::Abort
             *
             * @memberOf Lfl.Forms.SingleSubmitEnforcer
             */
            SingleSubmitEnforcer.engageDefault = function () {
                try {
                    if ($(DEFAULT_PATH).length !== 0) {
                        this.engageFor(DEFAULT_PATH)
                    }
                } catch (ex) {
                    console.error("Unable to `engage` single form submission for default elements. See the error:", ex);
                }
            };

            /**
             * Manually triggers the mechanism for default buttons.
             *
             * As of now relies on submit buttons (or other form submitting elements) containing the specified attribute.
             *
             * @memberOf Lfl.Forms.SingleSubmitEnforcer
             */
            SingleSubmitEnforcer.triggerDefault = function () {
                try {
                    if ($(DEFAULT_PATH).length !== 0) {
                        this.triggerFor(DEFAULT_PATH)
                    }
                } catch (ex) {
                    console.error("Unable to `trigger` single form submission for default elements. See the error:", ex);
                }
            };

            SingleSubmitEnforcer.abortDefault = function () {
                try {
                    if ($(DEFAULT_PATH).length !== 0) {
                        this.abortFor(DEFAULT_PATH)
                    }
                } catch (ex) {
                    console.error("Unable to `abort` single form submission for default elements. See the error:", ex);
                }
            }

            /**
             * Engages the mechanism for a given set of buttons (or other form submitting elements).
             *
             * @param {string} [path] Path to form submitting buttons that submit forms which should only be submitted
             * once.
             * @memberOf Lfl.Forms.SingleSubmitEnforcer
             */
            SingleSubmitEnforcer.engageFor = function (path) {
                const $elements = getElements(path);

                $elements.closest('form').on('submit', function (event) {
                    animateElements(path, $elements);
                })
            };

            /**
             * Manually triggers the mechanism for a given set of buttons (or other form submitting elements).
             *
             * @param {string} [path] Path to form submitting buttons that submit forms which should only be submitted
             * once.
             * @memberOf Lfl.Forms.SingleSubmitEnforcer
             */
            SingleSubmitEnforcer.triggerFor = function (path) {
                const $elements = getElements(path);

                animateElements(path, $elements);
            }

            SingleSubmitEnforcer.abortFor = function (path) {
                const $elements = getElements(path);

                showButtonIcon($elements);

                $elements.attr('disabled', false);

                if (animators.has(path)) {
                    animators.get(path).stop();
                    animators.delete(path);
                }
            }

            function getElements(path) {
                const $elements = $(path);

                if ($elements.length === 0) {
                    throw("Can not engage - no element matches path. Element path: " + path);
                }

                return $elements;
            }

            function animateElements(path, $elements) {
                /* Disable single submit elements */
                $elements.attr('disabled', true);

                /* Replace existing icon with loading icon */
                $elements.each(function () {
                    const dataAttribute = $(this).data('disable-loading-icon');

                    if (typeof dataAttribute === 'undefined') {
                        hideButtonIcon($(this));

                        const animator = new Lfl.Animations.ElementLoadingSpinnerAnimator({
                            $element: $(this)
                        });

                        animators.set(path, animator);
                        animator.start();
                    }
                });
            }

            function hideButtonIcon($buttons) {
                $buttons.find('.icon').hide();
            }

            function showButtonIcon($buttons) {
                $buttons.find('.icon').show();
            }
        }(Forms.SingleSubmitEnforcer, jQuery));
    }(Lfl.Forms, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
